import { DocumentData } from 'firebase/firestore';

export interface UserNotification {
  notificationId?: string;
  title: string;
  content: string;
  read: false;
  createdAt?: Date;
  type: NotificationType;
  parentUserId?: string;
  isActive?: true;
}

export enum NotificationType {
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
  Success = 'success',
}

export function mapToUserNotification(
  notification: DocumentData & { id?: string }
): UserNotification {
  return {
    notificationId: notification.id,
    title: notification['title'] || '',
    content: notification['content'] || '',
    read: notification['read'] || false,
    createdAt: notification['createdAt']?.toDate?.() ?? new Date(0),
    type: notification['type'] || NotificationType.Info,
    parentUserId: notification['parentUserId'] || undefined,
    isActive: notification['isActive'] || false,
  } as UserNotification;
}
